/**
 * ProfilePageShell — Feb 2026 Modern Theme Phase 3.
 * Theme-aware switcher. Modern variant omits the ThemeTogglePanel
 * subcomponent (since toggle is frozen).
 */
import { useTheme } from '../../context/ThemeContext';
import { ProfilePage } from './ProfilePage';
import { ProfilePageModern } from './ProfilePageModern';

export function ProfilePageShell() {
  const { isModern } = useTheme();
  return isModern ? <ProfilePageModern /> : <ProfilePage />;
}

export default ProfilePageShell;
